var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"no-auth-close"},[_vm._v("Доступ запрещён")])
}
var staticRenderFns = []

export { render, staticRenderFns }